// extracted by mini-css-extract-plugin
export var core = "Welcome-module--core--96e06";
export var cta = "Welcome-module--cta--78ef2";
export var img = "Welcome-module--img--d9a43";
export var paragraph = "Welcome-module--paragraph--e3a7f";